import { useNavigate } from 'react-router-dom';

import {
  isStageAlreadyExistsError,
  useLeadEventsCache,
  usePostLeadEvent,
} from '../../accountCreation';
import { getOnboardingResumePath } from '../../utils/onboardingResumePath';

import { mapTrainingCertifiedPayload } from '../mappers';
import { clearTrainingProgress } from '../services';

export function usePostTrainingCertifiedEvent() {
  const navigate = useNavigate();
  const { refetchLeadEvents, getCachedLeadEvents } = useLeadEventsCache();

  const mutation = usePostLeadEvent({
    invalidateEventsOnSuccess: false,
    mergeEventIntoCacheOnSuccess: false,
  });

  const submitCertified = async () => {
    const payload = mapTrainingCertifiedPayload();
    try {
      await mutation.mutateAsync(payload);
      return true;
    } catch (e) {
      if (isStageAlreadyExistsError(e)) {
        clearTrainingProgress();
        await refetchLeadEvents();
        navigate(getOnboardingResumePath(getCachedLeadEvents()), {
          replace: true,
        });
      }
      return false;
    }
  };

  return { submitCertified, isPending: mutation.isPending };
}
